export const SessionStorageItems = {
  SELECTED_ORG_DATA: 'selectedOrgData',
  STARTED_SESSION_WITH_INCOMPLETE_GUIDE: 'startedSessionWithIncompleteGuide',
  SETUP_ASSISTANT_MINIMIZED: 'setupAssistantMinimized',
  GW_AUTO_OPENED_FOR_GS: 'gwAutoOpenedForGs',
  ALMOST_THERE_MODAL_SHOWN: 'almostThereModalShown',
} as const;

export type SessionStorageItem =
  (typeof SessionStorageItems)[keyof typeof SessionStorageItems];
